<template>
  <vx-card :id="`question-card_${question.assessment.questionId}`" v-show="isCardActiveLocal" :style="{ 'background-color': question.status == 'correct' && quizType == 'graded' ? 'rgba(107, 255, 81, 0.3)' : question.status == 'answered' || quizType == 'survey' ? 'none' : 'rgba(255, 56, 56, 0.3)' }">
    <div class="vx-row">
      <div v-if="quizType == 'graded'" class="vx-col w-full">
        <p class="mb-2">{{ question.questionText }}</p>
        <span class="ml-0" v-for="(sentence, index) in sentenceResult" :key="index">
          <span v-if="sentence.type == 'text'">{{ sentence.text }}</span>
          <span v-else-if="sentence.type == 'blank'"><span><span :style="{'color': sentence.correct ? '#28c76f' : '#ea5455', 'font-weight': 700 }">{{ sentence.text }}</span>{{ sentence.correctAnswer ? ' (' : '' }}<span style="color: #28c76f">{{ sentence.correctAnswer }}</span><span>{{ sentence.correctAnswer ? ') ' : '' }}</span></span></span>
        </span>
        <div class="mt-2 vx-row">
          <vs-spacer></vs-spacer>
          <div class="vx-col">
            <p><small>Max Attempts: {{ question.maxAttempts }}</small></p>
            <p><small>Used Attempts: {{ question.usedAttempts }}</small></p>
          </div>
        </div>
      </div>
      <div v-else class="vx-col w-full">
        <p class="mb-2">{{ question.questionText }}</p>
        <span class="ml-0" v-for="(sentence, index) in sentenceResult" :key="index">
          <span v-if="sentence.type == 'text'">{{ sentence.text }}</span>
          <span v-else-if="sentence.type == 'blank'" :style="{'font-weight': 700 }">{{ sentence.text }}</span>
        </span>
      </div>
    </div>
    <comment-view :isCardActive="commentView" :question="question" :quizType="quizType" :predefinedComments="predefinedComments"/>
  </vx-card>
</template>

<script>
  import commentView from './iSpringCommentView.vue';
  export default {
    components: {
      commentView
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      question: {
        type: Object,
        required: false
      },
      questionCardTitle: {
        type: String,
        required: false
      },
      predefinedComments: {
        type:Array,
        required: false
      },
      quizType: {
        type: String,
        required: false
      }
    },
    data() {
      return {
        sentenceResult: [],
        commentView: true,
        showCorrectAnswer: false
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) {
          if (!val) {
            this.$emit("closeCard");
            this.initValues();
          }
        }
      },
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;
          if(self.question){
            
          }else{
            self.initValues();
          }
        }
      },
      question: function(val) {
        if(val){
          this.commentView = true;
        }
      }
    },
    methods: {
      setColor(index, question) {
        if(question.userMatches[index].premiseIndex == question.userMatches[index].responseIndex){
          this.showCorrectAnswer = false;
          return '#28c76f';
        }
        else{
          this.showCorrectAnswer = true;
          return '#ea5455';
        }
      },
      displaySentence() {
        var self = this;
        self.sentenceResult = [];
        var maxTextIndex = Math.max.apply(Math, self.question.text.map(function(text) { return text.index; }));
        var maxBlanksIndex = Math.max.apply(Math, self.question.blanks.map(function(blank) { return blank.index; }));
        var maxIndex = maxTextIndex > maxBlanksIndex ? maxTextIndex : maxBlanksIndex;

        for(var i = 0; i <= maxIndex; i++){
          var text = self.question.text.filter(function(item){ return item.index == i; });
          var blank = self.question.blanks.filter(function(item){ return item.index == i; });
          if(text.length > 0) {
            self.sentenceResult.push({ type: 'text', text: text[0].text });
          }else if(blank.length > 0) {
            var answerText = "";
            var correctAnswer = "";
            if(blank[0].answers){
              answerText = blank[0].answers[blank[0].userAnswerIndex];
              correctAnswer = blank[0].answers[blank[0].correctAnswerIndex];
            } else { 
              answerText = blank[0].userAnswer;
              correctAnswer = blank[0].correctAnswer;
            }

            self.sentenceResult.push({ type: 'blank', text: answerText, correctAnswer: correctAnswer, correct: blank[0].correct != null ? blank[0].correct : blank[0].answers[blank[0].correctAnswerIndex] == blank[0].answers[blank[0].userAnswerIndex] });
          }
        }
      },
      saveData() {
        this.initValues();
        this.$emit('saveData');
      },
      initValues() {
        
        this.errors.clear();
      },
      scrollToNavbar() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -500,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("navbarGlobal"), 500, scrollOptions);
      },
      scrollToFooter() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -480,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("footerGlobal"), 100, scrollOptions);
      },
    },
    mounted() {
      if(this.question)
        this.displaySentence();
    }
  }

</script>

<style lang="scss">

</style>
